<template>
  <el-container class="GlassContractSelect">
    <el-main class="p-0">      
      <ATable
        ref="table"
        v-loading="loading"
        :placeholder="searchPlaceHolder"
        :search_field="search_field"
        :data="items"
        :height="400"
        :row-class-name="addedTableRowClassName"        
        hideButtonExcel
        hide-button-insert
        hide-pagination
        @selection-change="selectionChange"
      >
        <div slot="search" class="list-title">
          <div class="inline">
            <APeriodSelector 
              ref="period"
              value="0d"
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column 
          type="selection" 
          align="center" 
          :selectable="selectable"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />        
        <el-table-column
          prop="contract_date"
          label="수주일"
          :width="$width.date"
        />
        <el-table-column
          prop="code"
          label="수주번호"
          width="90"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목"
          show-overflow-tooltip
        />
        <el-table-column
          prop="size"
          :label="$t('lang.size')"
          width="100"
        />
        <el-table-column
          prop="amount"
          label="수량"
          :formatter="util.numberFormat"
          width="50"
        />
        <el-table-column
          prop="supply_price"
          label="공급가"
          :formatter="util.numberFormat"
          class-name="cell-number"
          width="80"
        />
        <el-table-column
          prop="tax"
          label="세액"
          :formatter="util.numberFormat"
          class-name="cell-number"
          width="80"
        />
        <el-table-column
          prop="desc"
          label="비고"
          width="150"
          show-overflow-tooltip
        />        
        <el-table-column
          prop="order_date"
          label="발주일자"
          :width="$width.date"
        />
      </ATable>      
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        :disabled="selection.length < 1"
        v-shortkey="['f4']"
        @shortkey.native="clickSave"
        @click="clickSave"
      >등록 (F4)</el-button>
      <el-button 
        class="right"
        @click="closeDialog" 
      >{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";

export default {
  name: "GlassContractSelect",
  mixins: [form],
  data() {
    return {
      title: '유리수주',
      period: {},
      searchPlaceHolder: "수주번호, 거래처, 품목, 비고",
      search_field: ["code", "customer_name", "product_name", "desc"],
      searchWord: null,
      fixedSearchWord: "",      
      loading: false,
      items: [],
      selection: []
    };
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleClickFilter() {      
      this.fixedSearchWord = this.searchWord;
    },    
    loadData() {
      this.loading = true;
      /**
       * ERP-589 발주 > 수주 가져오기 개선
       * 전체 수주 정보를 가져오는 방식으로 변경
       */
      // let params = { product_kind: 'GLASS' };
      let params = {};
      this.api.listContractDetail(this.period, params).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = this.convertDescData(res.data);
      });
    },    
    convertDescData(data) {
      let field = null;
      let desc = null;
      data.forEach(item => {
        field = item.field ? (item.field + " "): "";
        desc = item.desc ? item.desc : "";
        item.desc = field + desc;
      });
      return data;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    addedTableRowClassName({ row /*, rowIndex*/ }) {
      if (!this.currentItems) {
        return null;
      }
      return this.currentItems.find(item => item.id === row.id)
        ? "added-row"
        : null;
    },
    selectionChange(selection) {      
      if (this.selection.length < selection.length) {
        let new_item = selection.filter(x => !this.selection.includes(x));
        if (new_item.length === 1) {
          new_item = new_item[0]
        }        
        //수주 등록건중 사양으로 현 기계의 사양으로 등록된 것을 같이 체크한다.
        if (new_item.contract_code) {          
          let spec_items = this.items.filter(d => {
            if (d.contract_code !== new_item.contract_code) { return false; }
            if (!new_item.specification) {
              return d.specification === new_item.seq;
            } else {
              return d.seq === new_item.specification || 
              d.specification === new_item.specification;
            }
          });
          if (spec_items.length > 0) {
            this.$nextTick(() => {
              spec_items.forEach(item => {
                this.$refs.table.toggleRowSelection(item, true);
              })
            });
          }
        }
        new_item.status_flag = '0';
      }
      selection.sort(function(a, b){ return a.id - b.id; });
      this.selection = selection;      
    },
    selectable(row) {
      return !row.order_detail_id;
    },
    handleCurrentChange(value) {
      this.currentPage = value;
    },

    saleStatusFormat(row, cell, cellValue) {
      return cellValue === "1" ? "완료" : "진행";
    },
    getSelection() {
      return this.$refs.table.selection;
    },

    /** 저장 */
    clickSave() {
      this.$emit("selceted", this.selection);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .added-row {
  color: grey;
}
</style>